import { generateHeadersAuth, generateHeadersCfTns } from "../auth/authFunctions"
import { apiProfilazioneGW, apiProfilazioneTS } from "./api"

export const getProfiloApiTS = async () => {
    return await apiProfilazioneTS.get("/profilo", { headers: generateHeadersCfTns() })
}

export const getProfiloApiSPID = async () => {
    return await apiProfilazioneGW.get("/profilo")
}

export const postProfiloApiTS = async (profilo) => {
    return await apiProfilazioneTS.post("/profilo", profilo, { headers: generateHeadersCfTns() })
}

export const postProfiloApiSPID = async (profilo) => {
    return await apiProfilazioneGW.post("/profilo", profilo)
}

export const patchProfiloApiTS = async (profilo) => {
    return await apiProfilazioneTS.patch("/profilo", profilo, { headers: generateHeadersCfTns() })
}

export const patchProfiloApiSPID = async (profilo) => {
    return await apiProfilazioneGW.patch("/profilo", profilo)
}

export const getPresaVisioneApiTS = async () => {
    return await apiProfilazioneTS.get("/presaVisione", { headers: generateHeadersCfTns() })
}

export const getPresaVisioneSPID = async () => {
    return await apiProfilazioneGW.get("/presaVisione")
}

export const getUltimaInformativaApiTS = async (codiceAsl) => {
    const queryParams = codiceAsl ? "?codiceAsl=" + codiceAsl : ""
    return await apiProfilazioneTS.get("/ultimaInformativa" + queryParams, { headers: generateHeadersAuth() })
}

export const postPresaVisioneApiTS = async () => {
    return await apiProfilazioneTS.post("/presaVisione", {}, { headers: generateHeadersCfTns() })
}

export const postPresaVisioneApiSPID = async () => {
    return await apiProfilazioneGW.post("/presaVisione")
}

export const getAvvisiUtenteApiTS = async () => {
    return await apiProfilazioneTS.get("/avvisi?targetPlatform=WEB", { headers: generateHeadersAuth() })
}